const TOKENKEY = 'accessToken'

// 存储
export function setToken(token) {
    if (token === undefined || token === null || token === '') {
        localStorage.removeItem(TOKENKEY)
        return
    }

    localStorage.setItem(TOKENKEY, token)
}

// 获取
export function getToken() {
    const token = localStorage.getItem(TOKENKEY)

    if (!token || token === 'undefined' || token === 'null') {
        return ''
    }

    return token
}

// 移除
export function removeToken() {
    localStorage.removeItem(TOKENKEY)
}
